module.exports = __webpack_public_path__ + "img/card-header.ff87ed0b.png";